export const GatewayType = {
    BANK_PORTAL:"درگاه بانکی",
    CHEQUE:"چک",
    CARD_TRANSFER:"انتقال کارتی",
    BANK_TRANSFER:"انتقال بانکی",
    ADMIN_PANEL:"درخواست از پنل",
}
